<template>
  <div v-if="alertResource.length > 0" class="has-text-centered my-4">
    <div v-if="alertResource != 'offer'">
      <LinkEntity
        :payload="alert.resources[alertResource]"
        :additional_data="{
          center: true,
          ...(alertResource == 'position' && { resource_type: 'Position' })
        }" />
      <br />
      <GhanaFlag
        v-if="alertResource != 'company'"
        :payload="alert.resources[alertResource]"
        :additional_data="{
          ...(alertResource == 'position' && { resource_type: 'Position' })
        }" />
      <br />
      <LinkEntity
        v-if="alertResource == 'position'"
        :payload="alert.resources['company']"
        :additional_data="{ center: true }" />
    </div>
    <div v-else>
      <LinkEntity
        :payload="alert.resources.applicant"
        :additional_data="{ center: true }" />
      <br />
      <GhanaFlag :payload="alert.resources.applicant" />
      <br />
      <LinkEntity
        :payload="alert.resources.position"
        :additional_data="{ center: true, resource_type: 'Position' }" />
      <br />
      <GhanaFlag
        :payload="alert.resources.position"
        :additional_data="{ resource_type: 'Position' }" />
      <br />
      <LinkEntity
        :payload="alert.resources.company"
        :additional_data="{ center: true }" />
      <br />
    </div>
  </div>
</template>

<script>
import LinkEntity from '@/components/LinkEntity'
import GhanaFlag from '@/components/GhanaFlag'

export default {
  name: 'FeedAlertResources',
  components: {
    LinkEntity,
    GhanaFlag
  },
  props: {
    alert: {
      type: Object
    }
  },
  computed: {
    alertResource () {
      const resource = this.alert.resource_type || ''
      return resource.toLowerCase()
    }
  }
}
</script>
